import React, { useState } from "react";

import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { useNavigate } from "react-router-dom";
import FadeInWrapper from "../../../../components/common/fade-in-wrapper";
import { notifyError } from "../../../../utils/toast";
import BackArrow from "../../../../components/common/back-arrow";

const REGISTER_COUPON_CODE = gql`
  mutation registerCouponCode($couponCode: String!) {
    registerCouponCode(couponCode: $couponCode) {
      ok
      error
    }
  }
`;

const CouponRegister = () => {
  const [couponCode, setCouponCode] = useState("");

  const [registerCouponCode] = useMutation(REGISTER_COUPON_CODE);
  const navigate = useNavigate();

  const handleCouponCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCouponCode(value);
  };

  const handleVerifyAuthNumber = async () => {
    const response = await registerCouponCode({
      variables: { couponCode },
    });
    if (response.data.registerCouponCode.ok) {
      navigate("/my/coupon/register/complete");
    } else {
      notifyError(response.data.registerCouponCode.error);
    }
  };

  return (
    <div className="h-full bg-white min-h-screen p-4">
      <FadeInWrapper className="flex flex-col h-full">
        <div onClick={() => navigate(-1)} className="p-1 mb-2">
          <BackArrow />
        </div>
        <h1 className="text-3xl text-black font-extrabold mt-4 mb-4">
          쿠폰 코드를 <br />
          입력해주세요
        </h1>
        <input
          type="text"
          value={couponCode}
          onChange={handleCouponCodeChange}
          placeholder="쿠폰 코드를 입력해주세요 (ex. 어피티 뉴스레터 코드)"
          className="border-b p-2 mb-4 w-full focus:outline-none"
          autoFocus
          maxLength={30}
        />

        <FadeInWrapper className="inline w-full mt-4">
          <button
            onClick={handleVerifyAuthNumber}
            className={`w-full h-[60px] flex items-center justify-center rounded-3xl font-bold bg-[#C2FC8E] text-black`}
          >
            등록하기
          </button>
        </FadeInWrapper>
      </FadeInWrapper>
    </div>
  );
};

export default CouponRegister;
